import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg, UserSession_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { union_type, bool_type, class_type, string_type, record_type, option_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import * as react from "react";
import { regularSwitch } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { value as value_2, map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { containsKey } from "../../../fable_modules/fable-library-js.4.19.0/Map.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import { bfsTile } from "../Shared/Tile.fs.js";

export class DashboardProps extends Record {
    constructor(GlobalDispatch, NavigateTo, MostRecentCallback) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.MostRecentCallback = MostRecentCallback;
    }
}

export function DashboardProps_$reflection() {
    return record_type("Dashboard.Shared.DashboardProps", [], DashboardProps, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["MostRecentCallback", option_type(obj_type)]]);
}

export function notificationBox(text, isChecked, isDisabled, onToggle, id) {
    const children_2 = [react.createElement("span", {
        className: "is-size-7 pr-2 has-text-grey-light",
    }, text), regularSwitch(isChecked, isDisabled, onToggle, "", id, [])];
    return react.createElement("div", {
        className: "notification-box",
    }, ...children_2);
}

export class NotificationTile_NotificationTileProps extends Record {
    constructor(GlobalDispatch, UniqueSessionKey, Flag, Title, Body, Session) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.UniqueSessionKey = UniqueSessionKey;
        this.Flag = Flag;
        this.Title = Title;
        this.Body = Body;
        this.Session = Session;
    }
}

export function NotificationTile_NotificationTileProps_$reflection() {
    return record_type("Dashboard.Shared.NotificationTile.NotificationTileProps", [], NotificationTile_NotificationTileProps, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["UniqueSessionKey", string_type], ["Flag", string_type], ["Title", string_type], ["Body", class_type("Fable.React.ReactElement")], ["Session", option_type(UserSession_$reflection())]]);
}

export class NotificationTile_Model extends Record {
    constructor(SessionKey, Visible, GlobalDispatch) {
        super();
        this.SessionKey = SessionKey;
        this.Visible = Visible;
        this.GlobalDispatch = GlobalDispatch;
    }
}

export function NotificationTile_Model_$reflection() {
    return record_type("Dashboard.Shared.NotificationTile.Model", [], NotificationTile_Model, () => [["SessionKey", string_type], ["Visible", bool_type], ["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)]]);
}

export class NotificationTile_Msg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["CloseDialog"];
    }
}

export function NotificationTile_Msg_$reflection() {
    return union_type("Dashboard.Shared.NotificationTile.Msg", [], NotificationTile_Msg, () => [[]]);
}

export function NotificationTile_State_init(props) {
    return [new NotificationTile_Model(props.UniqueSessionKey, !defaultArg(map((u) => containsKey(props.UniqueSessionKey, u.SessionData), props.Session), false), props.GlobalDispatch), Cmd_none()];
}

export function NotificationTile_State_update(msg, model) {
    model.GlobalDispatch(new GlobalMsg(7, [model.SessionKey, ""]));
    return [new NotificationTile_Model(model.SessionKey, false, model.GlobalDispatch), Cmd_none()];
}

export const NotificationTile_view = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\Shared.fs") + "#L") + int32ToString(value_2(66))) + ";") + "Dashboard.Shared.NotificationTile.NotificationTileProps", value_2("view"), (props) => {
    let children_5;
    let patternInput;
    const init = NotificationTile_State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, NotificationTile_State_update, (_arg, _arg_1) => {
    }), undefined, []);
    if (patternInput[0].Visible) {
        const children_9 = [bfsTile((children_5 = [react.createElement("div", {
            className: "notification-flag",
        }, props.Flag), react.createElement("div", {
            className: "notification-title-text",
        }, props.Title)], react.createElement("div", {
            className: "notification-title",
        }, ...children_5)), react.createElement("button", {
            className: "bfsdelete narrow",
            title: "schließen",
            onClick: (_arg_2) => {
                patternInput[1](new NotificationTile_Msg());
            },
        }), undefined, props.Body, undefined)];
        return react.createElement("div", {
            className: "notification-tile",
        }, ...children_9);
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, undefined, undefined, "Of");

//# sourceMappingURL=Shared.fs.js.map
